import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import PricingDescription from 'src/app/organisms/Homepage/PricingDescription/PricingDescription';
import PricingTextBlock from 'src/app/organisms/Homepage/PricingTextBlock/PricingTextBlock';

const Pricing = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-none']}
    paddingSm={['spacing-4xl', 'spacing-none']}
  >
    <Stack
      direction='column'
      gap='spacing-7xl'
      gapSm='spacing-6xl'
    >
      <PricingTextBlock />
      <PricingDescription />
    </Stack>
  </SectionLayout>
);

export default Pricing;
